
import { Model } from 'backbone';
import Immutable from 'immutable';

class ForgotPasswordModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default ForgotPasswordModel;
